var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-flex",staticStyle:{"height":"100%"}},[(_vm.days_left >0)?_c('ReminderMessage',{attrs:{"me":_vm.me}}):_c('ExpiredMessage',{attrs:{"me":_vm.me}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }